export default "__VITE_ASSET__738e6fe3__"